import { ListFilterPlus } from "lucide-react";
import LoadingSpinner from "./loading-spinner";
import { Button } from "./ui/button";
import { Skeleton } from "./ui/skeleton";

export default function TaskListHeaderSkeleton() {
    return (
        <>
            <div data-slot="header" className="px-4 py-2 pl-1.5  text-zinc-600 flex items-center gap-2 border-b justify-between min-h-[53px]">
                <div className="flex items-center">
                    <span className="size-9 grid place-items-center">
                        <LoadingSpinner className="size-3.5 absolute" />
                    </span>
                    <span>
                        <Skeleton className="h-3 w-[150px]" />
                    </span>
                </div>
                <div>
                    <Skeleton className="h-3 w-[120px]" />
                </div>
            </div>
            <div data-slot="filter" className="px-3 py-1  text-zinc-500 flex items-center gap-2 border-b justify-between min-h-[41px]">
                <div className="mr-auto">
                    <Button className="size-7 pointer-events-none" variant="ghost" size="icon">
                        <ListFilterPlus className="size-4 opacity-50" />
                    </Button>
                </div>
                <div className="flex items-center gap-2">
                    <Skeleton className="h-3 w-[140px]" />
                </div>
            </div>
        </>
    );
}
